export default __webpack_public_path__ + "static/media/social-03@2x.42d51174.webp";